import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerAltriRegistriModalComponent } from './worker-altri-registri-modal';

export const WorkerAltriRegistriModalModule: string = ng
    .module('worker-altri-registri-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerAltriRegistriModalComponent', WorkerAltriRegistriModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-altri-registri-modal/worker-altri-registri-modal.module.ts